package com.parmartechnologies.core.feature.chat.conversation.model

import com.parmartechnologies.core.extension.BaseDataClass
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable
import kotlin.time.ExperimentalTime

enum class ConversationType (val value:String) {
    CHAT("CHAT"),
    COUNSELING("COUNSELING"),
    BUSINESS_CHAT("BUSINESS_CHAT"),
}

@Serializable
data class Conversation @OptIn(ExperimentalTime::class) constructor(
    @SerialName("type") var type: ConversationType = ConversationType.CHAT,
    @SerialName("user_id") var UserID: String = "",
    @SerialName("business_id") var BusinessID: String = "",
    @SerialName("store_id") var storeId: String = "",
    @SerialName("admin_users") var AdminUsers: List<String>? = null,
    @SerialName("participants") var Participants: List<String>? = null,
    @SerialName("group_name") var GroupName: String = "",
    @SerialName("group_description") var GroupDescription: String = "",
    @SerialName("status_description") var StatusDescription: String = "",
    @SerialName("last_message") var LastMessage: String = "",
    @SerialName("is_group") var ISGroup: Int = 0,
    @SerialName("is_deleted") var IsDeleted: Int = 0,
    @SerialName("last_seen") var LastSeen: String = "",
): BaseDataClass()
